<template>
  <header-app titlepage="پروفایل" back="true"></header-app>
  <loading v-model:active="isLoading"
           :can-cancel="false"
           :on-cancel="onCancel"
           :is-full-page="fullPage"/>
  <v-main v-if="!isLoading" class="main">
    <div class="profileImg">
      <img :src="this.user.data.profile_image" width="100" id="UserProfileImage">
      <input type="file" name="avatar" id="imgInp" accept="image/*" @change="setimg" multiple/>
    </div>
    <v-divider/>
    <div class="profileForm">
      <div class="form-group">
        <div class="col-sm-12">
          <label class="label">
            نام و نام خانوادگی :
          </label>
          <input id="mobile-field" style="direction: ltr !important;" required v-model="user.data.name" type="text" class="form-control text-center" name="name" placeholder="نام و نام خانوادگی را وارد کنید">

        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <label class="label">
            ایمیل :
          </label>
          <input id="mobile-field" style="direction: ltr !important;" required v-model="user.data.email" type="email" readonly class="form-control text-center" name="email" placeholder="ایمیل خود را وارد کنید">

        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <label class="label">
            شماره موبایل :
          </label>
          <input id="mobile-field" style="direction: ltr !important;" required v-model="user.data.phone" type="text" class="form-control text-center" name="mobile" placeholder="شماره موبایل خود را وارد کنید">

        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <div class="btn btn-success" @click="updateProfile">
            بروزسانی پروفایل
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </v-main>
  <footer-app selectedItem="4"></footer-app>
</template>

<script>
import {defineComponent} from 'vue';

// Components
import HelloWorld from '../components/HelloWorld.vue';
import AboutView from "@/views/AboutView.vue";
import HeaderApp from "@/views/headerApp.vue";
import PicLink from "@/components/PicLink.vue";
import FooterApp from "@/views/FooterApp.vue";
import Category from "@/components/Category.vue";
import Products from "@/components/Products.vue";
import http from "@/plugins/axios";
import Loading from "vue-loading-overlay";

export default defineComponent({
  name: 'profile-view',
  data: () =>({
    isLoading: true,
    fullPage: true,
    user :  {
      data: [],
    },
  }),
  components: {
    Loading,
    Products,
    Category,
    FooterApp,
    PicLink,
    HeaderApp,
    HelloWorld,
  },
  methods:{
    getProfile(){

      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.post("/user/",'', { headers: { Authorization: AuthStr } })
          .then(response => {
            this.user = response.data;
            this.isLoading = false;
            console.log( this.user.data.id);
          })
          .catch((error) => {

          });
    },
    updateProfile(){
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.post("/update-user/",{
        name : this.user.data.name,
        email : this.user.data.email,
        phone : this.user.data.phone,
      }, { headers: { Authorization: AuthStr ,"Content-type": "multipart/form-data"} })
          .then(response => {
            this.user = response.data;
            this.isLoading = false;
            console.log( this.user.data.id);
          })
          .catch((error) => {

          });
    },
    setimg(event){
      const [file] = event.target.files;
      // console.log(file);
      if (file) {
        $('#UserProfileImage').attr('src', URL.createObjectURL(event.target.files[0]));

      }
    }
  },
  mounted() {
    this.getProfile();
  },
});
</script>

<style scoped>
  .main {
    padding: 60px 0 60px;
    direction: rtl;
  }
  .profileImg{
    text-align: center;
    position: relative;
    width: 100px;
    margin: 10px auto;
    border-radius: 50px;
    overflow: hidden;
    height: 100px;
  }
  .profileForm{
    width: 100%;padding: 10px;
  }
  .profileForm .form-group{
    margin: 10px auto;
  }
  .profileForm .form-group label{
    margin: 5px auto;
  }
  .profileForm .form-group .btn{
    margin: 10px auto;
    width: 100%;
  }
  .profileForm .form-group:first-child{
    margin-top: -20px !important;
  }
  #UserProfileImage input, .profileImg input {
    width: 100%;
    height: 68%;
    line-height: 200px;
    font-size: 200px;
    position: absolute;
    opacity: 0;
    z-index: 10;
    left: 0;
  }
</style>
